// src/pages/Payroll/PayrollDashboard.jsx
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../constant/constant";
import { decrypt } from "../../components/cryptoUtil";
import { Heading } from "../componenet/heading";
import { saveAs } from "file-saver"; // npm install file-saver
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PrintIcon from "@mui/icons-material/Print";


export default function PayrollDashboard() {
  const navigate = useNavigate();
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payrolls, setPayrolls] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
 
 
 
  const [filters, setFilters] = useState({ employeeId: "", month: new Date().getMonth() + 1, year: new Date().getFullYear() });

  // New state for collapsible payslip
  const [selectedPayslip, setSelectedPayslip] = useState(null);

  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
  }
const payslipRef = useRef(null);
  const token = localStorage.getItem("token") || "";
  const hospitalId = (decryptedData.softsubgroup || "").toString().toUpperCase();

  useEffect(() => {
    fetchStaff();
    fetchPayrollList();
  }, []);

  const fetchStaff = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/getAllStaff/${hospitalId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setStaffList(data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleGeneratePayroll = async () => {
    if (!filters.employeeId) {
      setSnackbar({ open: true, message: "Select an employee first", severity: "warning" });
      return;
    }
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/hospital/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filters),
      });
      const data = await res.json();
      setLoading(false);

      if (data.success) {
        setSnackbar({ open: true, message: "Payroll generated successfully", severity: "success" });
        fetchPayrollList();
      } else {
        setSnackbar({ open: true, message: data.message || "Failed to generate payroll", severity: "error" });
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      setSnackbar({ open: true, message: "Error generating payroll", severity: "error" });
    }
  };

  const fetchPayrollList = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${API_BASE_URL}/api/hospital/list/${hospitalId}?month=${filters.month}&year=${filters.year}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      setLoading(false);

      if (data.success) {
        const formatted = data.data.map((p) => ({
          payroll_id: p.payroll_id,
          staff_name: `${p.first_name} ${p.last_name}`,
          month: new Date(0, p.month - 1).toLocaleString("default", { month: "long" }),
          year: p.year,
          net_salary: p.net_salary,
        }));
        setPayrolls(formatted);
      } else {
        setSnackbar({ open: true, message: data.message || "Failed to fetch payroll list", severity: "error" });
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      setSnackbar({ open: true, message: "Error fetching payroll list", severity: "error" });
    }
  };

  // New: Fetch payslip details
  const viewPayslip = async (payroll_id) => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/hospital/payslip/${payroll_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setLoading(false);

      if (data.success) {


        console.log(data)



        setSelectedPayslip(data);
      } else {
        setSnackbar({ open: true, message: data.message || "Failed to fetch payslip", severity: "error" });
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      setSnackbar({ open: true, message: "Error fetching payslip", severity: "error" });
    }
  };

const downloadPayslipPDF = () => {
  if (!payslipRef.current) return;

  // Fixed width/height for A4 landscape in points
  const pdf = new jsPDF("l", "pt", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
 // const pdfHeight = pdf.internal.pageSize.getHeight();
  const padding = 20;

  // Temporarily set payslip container to fixed A4 width for html2canvas
  const originalStyle = payslipRef.current.style.cssText;
  payslipRef.current.style.width = `${pdfWidth - 2 * padding}px`; // subtract padding
  payslipRef.current.style.boxSizing = "border-box"; // include padding in width

  html2canvas(payslipRef.current, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");

    // Restore original styles
    payslipRef.current.style.cssText = originalStyle;

    // Fit image in PDF width, keep aspect ratio
    const imgWidth = pdfWidth - 2 * padding;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const xOffset = padding;
    const yOffset = padding; // top padding

    pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
    pdf.save(`Payslip_${selectedPayslip.payroll.staff_id}.pdf`);

    // Open PDF in a new window/tab and trigger print
    const blobUrl = pdf.output("bloburl");
    const printWindow = window.open(blobUrl);
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    }
  });
};




const monthNumber = selectedPayslip?.payroll?.month; // optional chaining
const monthName = monthNumber
  ? new Date(0, monthNumber - 1).toLocaleString("default", { month: "long" })
  : "";

  return (
    <Box sx={{ mt: 3 }}>
      <Card>
        <CardContent>
          <Heading headingtext="Payroll Management" />

          {/* Filters */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3 }}>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Employee</InputLabel>
              <Select
                label="Employee"
                value={filters.employeeId}
                onChange={(e) => setFilters({ ...filters, employeeId: e.target.value })}
              >
                {staffList.map((s) => (
                  <MenuItem key={s.employeeId} value={s.employeeId}>
                    {s.firstName} {s.lastname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Month</InputLabel>
              <Select
                value={filters.month}
                onChange={(e) => setFilters({ ...filters, month: e.target.value })}
                label="Month"
              >
                {[...Array(12).keys()].map((i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Year</InputLabel>
              <Select
                value={filters.year}
                onChange={(e) => setFilters({ ...filters, year: e.target.value })}
                label="Year"
              >
                {[2023, 2024, 2025, 2026].map((y) => (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button variant="contained" onClick={handleGeneratePayroll} disabled={loading}>
              {loading ? <CircularProgress size={22} color="inherit" /> : "Generate Payroll"}
            </Button>
          </Box>

          {/* Payroll Table */}

           <Box
  sx={{
    maxheight: 400, // instead of maxHeight
    overflowY: "auto",
    overflowX: "auto",
    mb: 2,
    border: "1px solid gray",
    borderRadius: 1,
  }}
>
          {payrolls.length ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Employee</TableCell>
                  <TableCell>Month</TableCell>
                  <TableCell>Year</TableCell>
                  <TableCell>Net Salary</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payrolls.map((p) => (
                  <TableRow key={p.payroll_id}>
                    <TableCell>{p.staff_name}</TableCell>
                    <TableCell>{p.month}</TableCell>
                    <TableCell>{p.year}</TableCell>
                    <TableCell>₹{p.net_salary}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => viewPayslip(p.payroll_id)}
                      >
                        View Payslip
                      </Button>
                     
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography color="text.secondary">No payrolls yet</Typography>
          )}
</Box>
          {/* Collapsible Payslip */}



        
        {selectedPayslip && selectedPayslip.payroll && selectedPayslip.details && (




  
  <Box
    sx={{
      position: "relative",
      width: "100%",
      maxWidth: "1123px", // A4 landscape width
     // height: "794px", // A4 landscape height
      bgcolor: "#f9f9f9",
      border: "1px solid gray",
      borderRadius: 2,
      boxShadow: 3,
      p: 3,
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
      overflowX: "auto",
    }}
  >
    {/* Scrollable content */}
    <Box
      ref={payslipRef}
      sx={{
       // flex: 1, // take remaining height
        
        pr: 1, // optional: padding for scrollbar
        width : 1100,
      }}
    >
      {/* Payslip Header */}
      <Box
        sx={{
          
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          mb: 1,
          borderBottom: "1px solid #1976d2",
          //pb: 1,
        }}
      >
        <Typography sx={{ fontSize: '10px', fontWeight: 'bold' }}>
          Payslip for: {selectedPayslip.payroll.first_name}{" "}
          {selectedPayslip.payroll.last_name}
        </Typography>
        <Typography sx={{ fontSize: '10px', fontWeight: 'bold' }}>
          EmpID: {selectedPayslip.payroll.staff_id || "N/A"}
        </Typography>
        <Typography sx={{ fontSize: '10px', fontWeight: 'bold' }}>
          Period:{" "}
          {new Date(0, (selectedPayslip.payroll.month || 1) - 1).toLocaleString(
            "default",
            { month: "long" }
          )}{" "}
          - {selectedPayslip.payroll.year}
        </Typography>
      </Box>

      {/* Earnings & Deductions */}
      {["Earning", "Deduction"].map((group) => {
        const components = selectedPayslip.details.filter(
          (d) => d.component_type === group
        );
        const total = components.reduce(
          (sum, c) => sum + Number(c.amount || 0),
          0
        );
        if (components.length === 0) return null;

        return (
          <Box key={group}  >
            <Typography variant="subtitle1" sx={{ fontSize: '10px', fontWeight: 'bold' }}>
              {group} : ₹{total.toFixed(2)}
            </Typography>
            <Box sx={{ borderBottom: "1px solid #ccc", mb: 1 }} />
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 , mb: 1}}>
              {components.map((c, i) => (
                <Typography key={i} sx={{ fontSize: '8px' }}>
                  {c.component_name} : ₹{Number(c.amount || 0).toFixed(2)}
                </Typography>
              ))}
            </Box>
          </Box>
        );
      })}

      {/* Net Salary */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
          borderBottom: "1px solid #1976d2",
          borderTop: "1px solid #1976d2",
         // pb: 1,
         // pt: 1,
        }}
      >
        <Typography sx={{ fontSize: '10px', fontWeight: 'bold' }}>
          Net Salary : ₹{Number(selectedPayslip.payroll.net_salary || 0).toFixed(2)}
        </Typography>
      </Box>
    

    </Box>

    {/* Buttons */}
       <Box display="flex" justifyContent="space-between" mt={2}  sx={{
        pr: 1, // optional: padding for scrollbar
        width : 1100,
      }}>
      <Button
        variant="contained"
        startIcon={<PrintIcon />}
        onClick={downloadPayslipPDF}
      >
        Download & Print Payslip
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={() => setSelectedPayslip(null)}
      >
        ❌ Close Payslip
      </Button>
    </Box>
   
  </Box>
// </Box>

)}




        </CardContent>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
